/************
 * List Tab Detail with right hand properties drawer
 * File Name ...: requests.components.ts
 * Generated By : ianday on 10/13/23
 * Date ........: 10/13/23
 *
 * Notes:
 * 	Collaboration Request codes are as follos:
 * 	0 - no request
 * 	1 - request (agency specific)
 * 	2 - broadcast request (any qualifying agency can answer).
 * 	Collaboration statuses:
 * 	Requested - waiting for others to respond.
 * 	Approved - an agency has approved the collaboration request
 * 	Denied - the agency has denied the collaboration request
 /************/

import { Component, OnInit, ViewChild, HostListener, AfterContentInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Settings } from '../../services/settings';
import { ServiceRequest } from '../../models/service.request';
import { ServiceRequestsService } from '../../services/service-requests.service';
import { ValidationResult } from '../../models/validation-result';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { TransactionHistoryService } from '../../services/transactionhistory.service';
import { TransactionHistoryComponent } from '../../components/transaction-history/transaction-history';
import { DwUtils } from '../../components/utils/dw-utils';
import { GlobalSearchComponent } from "./globalsearch/globalsearch.component";
import { RequestStatus } from 'src/app/models/request-status';
import { ServiceRequestType } from 'src/app/models/service-request-type';
import { CaseDetailsComponent } from '../common-tabs/case-details/case-details.component';
import { MembersComponent } from '../common-tabs/members/members.component';
import { CaseDocumentsComponent } from '../common-tabs/case-documents/case-documents.component';
import { AgenciesService } from 'src/app/services/agencies.service';
import { ServiceDefService } from 'src/app/services/servicedef.service';
import { ServiceDef } from 'src/app/models/service-def';
import { NotesComponent } from "../../components/notes/notes.component";
import { PastAssistanceComponent } from "./drawer/pastassistance/pastassistance.component";
import { interval } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { MailMessagesComponent } from "./drawer/mailmessages/mailmessages.component";
import { UOMRec } from '../settings/requesttypes/requesttypes.component';
import { AddNewRequestCompactComponent } from "./commands/add-new-request-compact/add-new-request-compact.component";
import { GeneralSetting } from "../../models/generalsetting";


export class dataRecord {
	public id: any;
	public description: string;
	constructor(id: any, desc: string) {
		this.id = id;
		this.description = desc;
	}
}

@Component({
	selector: 'app-requests',
	templateUrl: './requests.component.html',
	styleUrls: ['./requests.component.css']
})
export class RequestsComponent implements OnInit, AfterContentInit {

	/*** Header / Query Strip Variables ****/
	public formTitle = 'Requests';
	public pagination: string;
	strFilterText = '';


	/*** Editing variables ***/
	public isAdd: boolean | null = false;
	public records: ServiceRequest[];
	public selectedRecord: ServiceRequest;
	public historyRecord: ServiceRequest;
	public Idx: number | null = -1;
	public strErr: string | null = '';
	public dataSource: MatTableDataSource<ServiceRequest>;
	public renderedData: Array<any>;
	public result: boolean | null = false;
	public disabledFlag: boolean | null = true;
	public activeCellId: string | null = '';
	public drawTabIndex: number | null = 0;					/* reset to zero */

	/**** Query strip filter settings ***/
	public selectedStatusFilter: RequestStatus;
	public selectedViewFilter: string | null = 'My Requests';
	public contentClassWithBanner: string | null = 'dwtable-container-local-requests';
	public contentClassWithoutBanner: string | null = 'dwtable-container-without-header-local-requests';
	public contentClassName: string | null = 'dwtable-container-requests';

	/*** Record Table / card table  ***/
	public displayedColumns: string[] = ['collaborationRequest', 'caseNumber', 'caseName', 'agencyName', 'id', 'serviceRequestDesc', 'dateCreated', 'dueDate', 'daysLapsed', 'daysLeft', 'amountRequested', 'totalAmountProvided', 'requestStatusDesc', 'keepOpen', 'btnDetails'];

	/*** dialog variables ***/
	public displaySearchDlg = false;
	public displayRequestDetailsDlg = false;
	public displayCaseDetailsDlg = false;

	/***** Control Strip Button Visibility ***/
	public visibleAdd: boolean | null = false;
	public visibleMatch: boolean | null = false;
	public visibleApprove: boolean | null = false;
	public visibleStatus: boolean | null = false;
	public visibleCollaborate: boolean | null = false;

	public visibleGlobalSearch = false;

	/***** Tab Detail Section *****/
	public selectedTabIndex: number | null = 0;
	public id: any | null = '';
	public description: any | null = '';
	public activeStatus: any | null = '';
	public busyCursor: boolean | null = false;
	selectedCaseId = 0;
	public showList: Array<dataRecord>;
	public showStatusList: Array<dataRecord>;
	public uomList;
	public shiftKeyPressed = false;

	/***** Side drawer ****/

	public propContainerState: boolean | null = true;  /** set to false ***/
	public visiblePropertiesTab: boolean | null = true;
	public saveSortEvent: any | null;
	/***** Data Section *****/

	public requestStatuses: RequestStatus[];
	public serviceRequestTypes: ServiceRequestType[];
	public serviceDefsList: ServiceDef[];
	public bannerEnabled = false;

	globalSearchCustomFilter = new dataRecord('Custom', 'Custom');
	autoRefreshInProgress = false;
	isRequestDetailsEditing = false;

	showRequestDetailsdialog = false;
	showCaseDetailsdialog = false;
	showRestrictedStatusFilter = false;
	showUnLimitedStatusFilter = false;

	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('history', { static: true }) history: TransactionHistoryComponent;
	@ViewChild('casedetails', { static: true }) casedetails: CaseDetailsComponent;
	@ViewChild('members', { static: true }) members: MembersComponent;
	@ViewChild('case-documents', { static: true }) casedocuments: CaseDocumentsComponent;

	@ViewChild('globalSearch', { static: true }) globalSearch: GlobalSearchComponent;

	/*** Drawer Children ***/
	@ViewChild('pastAssistance', { static: true }) pastAssistance: PastAssistanceComponent;
	@ViewChild('notes', { static: true }) notes: NotesComponent;
	@ViewChild('mailMessages', { static: true }) mailMessages: MailMessagesComponent;

	/*** New Service Request Dialog ***/
	@ViewChild('newRequest', { static: true }) newRequest: AddNewRequestCompactComponent;

	showHouseholdTab = false;
	private alive = true; // Used to control the interval subscription

	constructor(public serviceRequestsService: ServiceRequestsService, private txService: TransactionHistoryService,
		public dialog: MatDialog, public agenciesService: AgenciesService, private serviceDefService: ServiceDefService) {
		this.selectedRecord = new ServiceRequest();
		const isAdmin = Settings.getInstance().loggedInUser.security_elements.some(item => item.role === 'ADMIN');
		this.showList = new Array();

		this.showList.push(new dataRecord('My Requests', 'My Requests'));
		this.showList.push(new dataRecord('Completed', 'My Completed Requests'));
		this.showList.push(new dataRecord('My Overdue Requests', 'My Overdue Requests'));

		if (Settings.getInstance().hasPrivilege('REQUESTS_SHOW_FILTER_ALL_OVERDUE_COMPLETE', 'SHOW')) {

			this.showList.push(new dataRecord('All Overdue Requests', 'All Overdue Requests'));
		}
		// UNMATCHED is separate and unrelated  check independently
		if (Settings.getInstance().hasPrivilege('REQUESTS_SHOW_FILTER_ALL_UNMATCHED', 'SHOW')) {
			this.showList.push(new dataRecord('Unmatched', 'All Unmatched Requests'));
		}


		this.serviceRequestsService.refreshEvent.subscribe(() => {
			if (this.displayRequestDetailsDlg === true) {
				return;
			}
			this.refreshButtonClickHandler();
		});
		let genkey: any = Settings.getInstance().getGeneralSettingByKey('bannerenable');
		if (genkey === undefined || genkey === null) {
			genkey = new GeneralSetting();
			genkey.value = 'true';
		}
		this.bannerEnabled = DwUtils.stringToBool(genkey.value);

	}

	public ngOnInit() {
		this.visibleAdd = true;
		this.visibleMatch = true;
		this.visibleApprove = true;
		this.visibleStatus = true;
		this.visibleCollaborate = true;
		this.visibleGlobalSearch = (Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH', "EXECUTE") || Settings.getInstance().hasPrivilege('REQUEST_GLOBAL_SEARCH', "SHOW"));
		this.showRequestDetailsdialog = Settings.getInstance().hasPrivilege('REQUEST_DETAIL', "SHOW")
		this.showRestrictedStatusFilter = Settings.getInstance().hasPrivilege('REQUEST_RESTRICTED_STATUS_FILTER', "SHOW");
		this.showUnLimitedStatusFilter = Settings.getInstance().hasPrivilege('REQUEST_UNRESTRICTED_STATUS_FILTER', "SHOW");
		interval(Settings.getInstance().RequestGridAutoRefreshMinutes * 60000)
			.pipe(takeWhile(() => this.alive))
			.subscribe(() => {
				this.refreshData(true);
			});

		this.serviceDefService.getActiveUnitOfMeasures().subscribe(
			(result) => {
				this.uomList = new Array();
				for (const rec of result) {
					this.uomList.push(new UOMRec(rec.description, rec.description));
				}
				Settings.getInstance().uomList = this.uomList;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'fetching UOMs')
			});

	}
	ngOnDestroy() {
		// Ensure to unsubscribe when the component is destroyed
		this.alive = false;
	}
	public ngAfterContentInit() {
		if (Settings.getInstance().agencyList === undefined) {
			this.loadAgencyList();
		}
		this.setContentClass();
		this.queryRecords();
	}
	/** set the content class for banner or no-banner **/
	public setContentClass(): void {

		if (this.bannerEnabled === true) {
			this.contentClassName = this.contentClassWithBanner;
		}
		else {
			this.contentClassName = this.contentClassWithoutBanner;
		}
	}

	/*** Query Records from the Service ***/
	public queryRecords() {
		this.busyCursor = true;

		if (this.bannerEnabled === true) {
			this.contentClassName = this.contentClassWithBanner;
		} else {
			this.contentClassName = this.contentClassWithoutBanner;
		}

		this.serviceRequestsService.getAllActiveRequestStatuses().subscribe(
			(result) => {
				this.busyCursor = false;
				this.showStatusList = new Array();
				this.requestStatuses = result;
				const deepClone = <T>(obj: T): T => JSON.parse(JSON.stringify(obj));
				Settings.getInstance().requestStatuses = deepClone(result);
				let statusAll: RequestStatus = new RequestStatus();
				statusAll.shortDescription = 'All';
				statusAll.id = 0;
				this.requestStatuses.push(statusAll);
				//this.showStatusList.push(new dataRecord(0, 'All'));
				if (this.showUnLimitedStatusFilter) {
					// include all
				} else if (this.showRestrictedStatusFilter) {
					result = result.filter(s => s.selectable === 1);
				}
				for (const rec of result) {
					if (rec.shortDescription.includes("Agency Denied")) {
						continue;
					}

					this.showStatusList.push(new dataRecord(rec.id, rec.shortDescription));
				}
				//this.requestStatuses.unshift({ id: 0, shortDescription: 'ALL', recordStatus: '1', description: '' });
				this.selectedStatusFilter = this.getDefaultStatusFilterValue();
				this.busyCursor = true;
				this.serviceRequestsService.getAllServiceRequestTypes().subscribe(
					(result1) => {
						this.serviceRequestTypes = result1;
						Settings.getInstance().serviceRequestTypesList = result1;
						this.busyCursor = false;
						this.serviceDefService.getAllServiceDef().subscribe(
							(result2) => {
								this.serviceDefsList = result2;
								Settings.getInstance().serviceDefsList = result2;
								this.busyCursor = false;
								this.queryRequestData();
							},
							(error2) => {
								Settings.getInstance().handleError('Error: unable to retrieve service defs from' +
									' the' +
									' service');
								this.busyCursor = false;

							}
						);
					},
					(error1) => {
						Settings.getInstance().handleError('Error: unable to retrieve request types from the service');
						this.busyCursor = false;
					}
				);
			},
			(error) => {
				Settings.getInstance().handleError('Error: unable to retrieve service requests from the service');
				this.busyCursor = false;
			}
		);
	}
	public loadAgencyList() {

		this.agenciesService.getAllAgencies().subscribe(
			(result) => {
				Settings.getInstance().agencyList = result;
			},
			(error) => {
				Settings.getInstance().handleError(error, 'Error: unable to retrieve agency data from the service');
			}
		);
	}
	public queryRequestData(autoRefreshFlag: boolean = false) {
		let dataObservable;
		this.autoRefreshInProgress = autoRefreshFlag;

		let localSelected = this.selectedRecord;

		this.busyCursor = true;
		if (this.selectedViewFilter === 'Unmatched') {
			dataObservable = this.serviceRequestsService.getAllServiceRequestsByRequestStatusId(1);
		} else if (this.selectedViewFilter === 'My Requests') {
			this.selectedStatusFilter = this.getDefaultStatusFilterValue();
			dataObservable = this.serviceRequestsService.getAllRequestsByAgencyIdAndRecordStatus(Settings.getInstance().loggedInUser.agencyId, 3);
		} else if (this.selectedViewFilter === 'Completed') {
			dataObservable = this.serviceRequestsService.getAllRequestsByAgencyIdAndRecordStatus(Settings.getInstance().loggedInUser.agencyId, 0);
		}
		else if (this.selectedViewFilter === 'All Overdue Requests') {
			dataObservable = this.serviceRequestsService.getOpenAndOverDueServiceRequests(0);
		}
		else if (this.selectedViewFilter === 'My Overdue Requests') {
			dataObservable = this.serviceRequestsService.getOpenAndOverDueServiceRequests(Settings.getInstance().loggedInUser.agencyId);
		}
		else if (this.selectedViewFilter === 'Custom') {
			this.selectedViewFilter = 'My Requests';
			this.selectedStatusFilter = this.getDefaultStatusFilterValue();
			dataObservable = this.serviceRequestsService.getAllRequestsByAgencyIdAndRecordStatus(Settings.getInstance().loggedInUser.agencyId, 3);
		}
		if (dataObservable) {
			dataObservable.subscribe(
				(result: any) => {
					this.records = result;
					this.busyCursor = false;
					for (const rec of this.records) {
						const keepOpenValue = String((rec as any).keepOpen).toLowerCase();
						rec.keepOpen = ((rec as any).keepOpen === true || (rec as any).keepOpen === 1 || keepOpenValue === '1' || keepOpenValue === 'true') ? 1 : 0;
						if (rec.serviceDefId) {
							const serviceDef = Settings.getInstance().getServiceDef(rec.serviceDefId);
							if (serviceDef) {
								rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId) + ': ' + serviceDef.description;
							} else {
								rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId);
							}
						} else {
							rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId);
						}
						rec['agencyName'] = this.getAgencyName(rec.agencyId);
						rec.requestStatusDesc = this.getRequestStatusDesc(rec.requestStatusId);
						rec.collabList = '';
					}
					this.dataSource = new MatTableDataSource(this.records);
					this.dataSource.sort = this.sort;
					if (this.saveSortEvent !== undefined) {
						this.onSortChange(this.saveSortEvent);
					}

					if (this.selectedViewFilter === 'Unmatched') {
						this.selectedStatusFilter = this.getRequestStatusRecordByDesc('Unmatched');
					}
					if (this.selectedViewFilter === 'Completed') {
						this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
					}
					if (this.selectedViewFilter === 'My Overdue Requests') {
						this.selectedStatusFilter = this.getRequestStatusRecordByDesc('Matched');
					}
					if (this.selectedViewFilter === 'All Overdue Requests') {
						this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
					}
					this.onChangeStatusFilterValue();

					this.setPagination(-1, this.dataSource.data.length);

					/** if this is an autorefresh, re-select the same
					 * record after the refresh **/
					if (autoRefreshFlag === true) {
						this.applyFilter(this.strFilterText);
						if (localSelected.id > 0) {
							this.selectedRecord = localSelected;
							this.selectRow();
							DwUtils.setFocus('requestTableId');
						}
					}
					else {
						DwUtils.setFocus('txtFilter');
					}
					this.setContentClass();
				},
				(error) => {
					Settings.getInstance().handleError('Error: unable to retrieve request data from the service');
					this.busyCursor = false;
				}
			);
		}
	}
	public atoi(inp: string): number {
		return Number(inp);
	}
	/*** Display the number of records from the total ***/
	public setPagination(idx: number, total: number) {
		this.pagination = (idx + 1) + '/' + total;
	}
	public onChangeStatusFilterValue() {
		const dataTemp: ServiceRequest[] = [];
		if (!this.autoRefreshInProgress === true) {
			this.clearFilter();
		}
		this.clear();
		if (!this.selectedStatusFilter) {
			this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
		}
		for (const rec of this.records) {
			if (rec.requestStatusId === this.selectedStatusFilter.id || this.selectedStatusFilter.id === 0) {
				dataTemp.push(rec);
			}
		}
		this.dataSource = new MatTableDataSource(dataTemp);
		this.setPagination(-1, this.dataSource.filteredData.length);
		this.selectRow();
	}
	public onChangeViewFilterValue() {
		this.showList = this.showList.filter(record => record !== this.globalSearchCustomFilter);
		this.clear();
		if (this.selectedViewFilter === 'My Requests') {
			this.selectedStatusFilter = this.getDefaultStatusFilterValue();
		}
		this.dataSource = null;
		this.queryRequestData();
	}

	public doTabChange(event): void {
		if (this.selectedRecord) {
			this.displayDetail(this.selectedRecord);
		}
	}
	@HostListener('matSortChange', ['$event'])
	public onSortChange(event: any) {
		this.saveSortEvent = event;
		if (this.dataSource === undefined || this.records === undefined) {
			return;
		}
		try {
			const propComparator = (a: any, b: any) => {
				const propA = this.getPropertyValue(a[event.active]);
				const propB = this.getPropertyValue(b[event.active]);

				if (typeof propA === 'number' && typeof propB === 'number') {
					return event.direction === 'asc' ? propA - propB : propB - propA;
				} else if (propA instanceof Date && propB instanceof Date) {
					return event.direction === 'asc' ? propA.getTime() - propB.getTime() : propB.getTime() - propA.getTime();
				} else {
					const propAStr = propA.toString();
					const propBStr = propB.toString();
					return event.direction === 'asc' ? propAStr.localeCompare(propBStr) : propBStr.localeCompare(propAStr);
				}
			};

			this.dataSource.data = this.dataSource.data.sort(propComparator);
			this.selectRow();
			this.setPagination(this.Idx, this.dataSource.filteredData.length);
		} catch (e) {
			console.log(e);
		}
	}

	public getPropertyValue(value: any): any {
		// Handle special cases for specific data types (e.g., date, number)
		// Add more cases as needed based on the data types
		if (value instanceof Date) {
			return value;
		} else if (!isNaN(value)) {
			return parseFloat(value);
		} else {
			return value ?? '';
		}
	}
	public clearFilter() {
		if (this.dataSource === undefined) {
			return;
		}
		//this.unSelectRow();
		this.dataSource.filter = '';
		this.strFilterText = '';
		this.selectRow();
		this.setPagination(-1, this.dataSource.data.length);
		DwUtils.setFocus('txtFilter');
	}
	public applyFilter(filterValue: string) {

		if (this.dataSource === undefined) {
			return;
		}

		this.dataSource.filter = filterValue.trim().toLowerCase();
		this.unSelectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public selectRow() {
		if (this.selectedRecord.id === 0) {
			this.unSelectRow();
			return;
		}
		this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
		this.reloadSelectedRecord(); // For auto refresh row selection
	}
	public reloadSelectedRecord() {
		if (!this.selectedRecord || this.selectedRecord.id === 0) {
			return;
		}
		for (const rec of this.records) {
			if (this.selectedRecord.id === rec.id) {
				this.selectedRecord = rec;
				this.setServiceRequestDesc(this.selectedRecord);
				this.displayDetail(this.selectedRecord);
				return;
			}
		}
	}
	public unSelectRow() {

		if (this.dataSource === undefined) {
			return;
		}

		this.Idx = -1;
		this.selectedRecord = new ServiceRequest();
		this.setPagination(this.Idx, this.dataSource.data.length);
		this.displayDetail(this.selectedRecord);

	}
	public setServiceRequestDesc(record: ServiceRequest): void {
		let serviceRequestDesc = this.getRequestTypeDesc(record.serviceRequestTypeId);

		if (record.serviceDefId) {
			const serviceDef = Settings.getInstance().getServiceDef(record.serviceDefId);
			if (serviceDef) {
				serviceRequestDesc += `: ${serviceDef.description}`;
			}
		}
		record.serviceRequestDesc = serviceRequestDesc;
	}
	public displayDetail(record: ServiceRequest) {


	}
	public clear(): void {
		this.selectedRecord = new ServiceRequest();
		this.displayDetail(this.selectedRecord);
	}
	public amountLabel(id: number, requestFlag: boolean): string {
		if (id === null || !this.records) { return '-'; }

		const selected = this.records.find(s => s.id === id);
		if (selected === undefined) { return ''; }
		if (selected.unitOfMeasure === undefined) { selected.unitOfMeasure = '' }

		let val: number = null;
		if (requestFlag === true) {
			val = selected.amountRequested;
		}
		else {
			val = selected.totalAmountProvided;
		}

		return DwUtils.returnAmountString(val, selected.unitOfMeasure);
	}
	public tableKeyDown(event: KeyboardEvent) {

		if (event.key === 'Shift') {
			this.shiftKeyPressed = true;
		}
		else {
			this.shiftKeyPressed = false;
		}

		const len: number = this.dataSource.filteredData.length;
		if (event.key === 'ArrowDown') {
			if (this.Idx < (len - 1)) {
				this.selectedRecord = this.dataSource.filteredData[++this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		} else if (event.key === 'ArrowUp') {
			if (this.Idx > 0) {
				this.selectedRecord = this.dataSource.filteredData[--this.Idx];
				this.displayDetail(this.selectedRecord);
			}
		}
		this.setPagination(this.Idx, this.dataSource.filteredData.length);
	}
	public validateFields(): boolean {

		this.strErr = '';
		const vr: ValidationResult = this.selectedRecord.validateRecord();

		if (vr.error.length > 0) {
			this.strErr = vr.error;
			DwUtils.setFocus(vr.focus_field);
			return false;
		}
		return true;
	}
	/* Update the record in the table's data source - without refreshing it */
	public updateSelectedRow(): void {

		if (this.isAdd === true) {
			// add the new record to the top.
			this.records.unshift(this.selectedRecord);
			this.dataSource.data = this.records;
			this.Idx = 0;
		} else {
			const i: number = this.records.findIndex(r => r.id === this.selectedRecord.id);
			this.records[i] = this.selectedRecord;
			this.dataSource.data = this.records;
		}
		/*** apply filters if valid ***/
		this.onChangeStatusFilterValue();
		this.dataSource.sort = this.sort;

	}
	public onRowClicked(selected: any) {

		this.selectedRecord = selected;
		this.selectRow();
		this.setPagination(this.Idx, this.dataSource.filteredData.length);

		if (this.shiftKeyPressed === true) {
			this.shiftKeyPressed = false;
			const hasCase = Settings.getInstance().hasPrivilege('CLIENTS_CASE_DETAILS','SHOW');

			if (hasCase === true) {
				this.doCaseDetails();
			}
		}
	}

	public onRowDoubleClicked(selected: any) {

		this.selectedRecord = selected;
		this.displayCaseDetailsDlg =false;
		this.shiftKeyPressed = false;
		this.doRequestDetails();
		//this.doRequestDetails();
	}
	public onClipboardClicked(selected: any): void {
		this.selectedRecord = selected;
		

		if (this.shiftKeyPressed) {
			this.shiftKeyPressed = false;
			this.doCaseDetails();
		} else{
			this.doRequestDetails();	
		}
	}
	public doCaseDetails(): void {
		this.displayCaseDetailsDlg = true;
		this.shiftKeyPressed = false;

	}
	public doCaseDlgClose(): void {
		this.displayCaseDetailsDlg = false;
		this.shiftKeyPressed = false;
		DwUtils.setFocus('requestTableId');
	}
	public doRequestDetails(): void {
		if (!this.showRequestDetailsdialog) {
			return;
		}
		if (this.selectedRecord) {
			this.displayRequestDetailsDlg = true;
		}
	}
	public cancelSubmitRecord() {
		this.strErr = '';
		this.displayDetail(this.selectedRecord);
	}
	/*** dialogs ***/
	public doGlobalSearch(): void {
		this.displaySearchDlg = true;
		this.globalSearch.onShowHandler();
		this.globalSearch.doInitialize();
	}
	public globalSearchSelect(eventData: any): void {
		this.displaySearchDlg = false;
		this.records = eventData;
		this.dataSource = new MatTableDataSource(this.records);
		this.showList = this.showList.filter(record => record !== this.globalSearchCustomFilter);
		this.showList.push(this.globalSearchCustomFilter);
		this.selectedViewFilter = 'Custom';
		this.selectedStatusFilter = this.getRequestStatusRecordByDesc('All');
		this.setPagination(-1, this.records.length);
	}
	public getDefaultStatusFilterValue() {
		for (const rec of this.requestStatuses) {
			if (rec.shortDescription === 'Matched') {
				return rec;
			}
		}
		return new RequestStatus();
	}
	public getRequestTypeDesc(paramId: number) {
		if (!this.serviceRequestTypes) {
			return;
		}
		for (const rec of this.serviceRequestTypes) {
			if (rec.id === paramId) {
				return rec.description;
			}
		}
		return 'Undefined';
	}
	public getBackgroundColor(record: any): string {

		//const finalizedStatusIds = [3, 4, 5, 8, 9]; // Define finalized status IDs
		//if (finalizedStatusIds.includes(record.requestStatusId)) {

		if (record.recordStatus === 0) {
			return 'lightgrey'; // Closed requests
		}

		if (record.daysLeft <= 2) {
			return '#ff6c6c'; // Red background for overdue, 0, 1, 2 days left
		} else if (record.daysLeft <= 5) {
			return '#ffbf6c'; // Orange background for 3, 4, 5 days left
		} else {
			return '#29db69'; // Green background for more than 5 days left
		}
	}

	public getCollaborationIconColor(item: string): string {

		switch (item) {
			case '':
				return 'transparent';
			case 'Planned':
				return 'var(--buttonBlue)';
			case 'Requested':
				return 'orange';
			case 'Committed':
				return 'var(--appcolor)';
			case 'Denied':
				return 'var(--redTheme)'
		}

		return 'transparent';
	}

	public getServiceDefDescription(serviceDefId: number) {
		return Settings.getInstance().getServiceDefDescription(serviceDefId);
	}
	public getAgencyName(agencyId: number) {
		return Settings.getInstance().getAgencyName(agencyId);
	}
	public refreshButtonClickHandler() {
		if (this.displayRequestDetailsDlg === true) {
			return;
		}
		if (this.selectedViewFilter === 'Custom') {
			return;
		}
		this.records = [];
		this.dataSource = new MatTableDataSource(this.records);
		this.queryRequestData();
	}
	public refreshData(autoRefreshFlag: boolean) {

		/** If any of the dialog boxes are open
		 * Suspend the refresh **/

		if (this.displayRequestDetailsDlg === true) {
			return;
		}
		if (this.displaySearchDlg === true) {
			return;
		}
		if (this.selectedViewFilter === 'Custom') {
			return;
		}
		this.queryRequestData(autoRefreshFlag);
	}
	public handleCollabFocus(element: any) {

		this.serviceRequestsService.getParticipatingAgencyIds(element.id).subscribe(
			(result) => {
				if (result.length > 0) {
					element.collabList = this.prepareCollabList(element, result);
				} else {
					element.collabList = 'No data available';
				}
			},
			(error) => {
				console.error(error);
			}
		);
	}
	public prepareCollabList(request: ServiceRequest, agencyIds) {
		let collabListString = '';
		for (const rec of agencyIds) {
			const agencyName = Settings.getInstance().getAgencyName(Number(rec.agencyId));
			collabListString = collabListString + ' - ' + agencyName + '\n';
		}
		return collabListString;
	}
	public requestStatusLabel(requestStatusId: number): string {
		return this.getRequestStatusDesc(requestStatusId);
	}
	public getRequestStatusDesc(paramId: number) {
		for (const rec of Settings.getInstance().requestStatuses) {
			if (rec.id === paramId) {
				//console.log('paramId: '+paramId+'   '+rec.id+' '+rec.description+'   '+rec.shortDescription);
				return rec.shortDescription;
			}
		}
		return 'Undefined';
	}
	public getRequestStatusRecordByDesc(param: string) {
		for (const rec of this.requestStatuses) {
			if (rec.shortDescription === param) {
				return rec;
			}
		}
		return undefined;
	}
	public doClose() {
		this.displayRequestDetailsDlg = false;
		/** set focus to the table so that a shift-click or shift-clipboard can be heard **/
		if (this.selectedRecord.agencyId) {
			this.selectedRecord['agencyName'] = this.getAgencyName(this.selectedRecord.agencyId);
		}
		/** The global-search ("Custom") view is never auto-refreshed (refreshData
		 * returns early for it), which left the edited row showing a stale Status
		 * and collaboration icon until a manual Refresh. Re-fetch just the edited
		 * row so it matches a full Refresh without rebuilding the search results. **/
		if (this.selectedViewFilter === 'Custom') {
			this.refreshCustomRow(this.selectedRecord ? this.selectedRecord.id : 0);
		} else {
			this.refreshData(true);
		}
		DwUtils.setFocus('requestTableId');
		//this.reloadSelectedRecord();
	}
	/* Re-fetch a single row in list shape and patch it in place. Used only for the
	 * Custom (global search) view so Status + collaboration icon (plannedCommitted)
	 * reflect the server after approve/close, mirroring a full Refresh. */
	private refreshCustomRow(id: number): void {
		if (!id || !this.records) {
			return;
		}
		this.serviceRequestsService.getServiceRequestListRow(id).subscribe(
			(rec: any) => {
				if (!rec) {
					return;
				}
				/** decorate exactly like queryRequestData does **/
				const keepOpenValue = String((rec as any).keepOpen).toLowerCase();
				rec.keepOpen = ((rec as any).keepOpen === true || (rec as any).keepOpen === 1 || keepOpenValue === '1' || keepOpenValue === 'true') ? 1 : 0;
				if (rec.serviceDefId) {
					const serviceDef = Settings.getInstance().getServiceDef(rec.serviceDefId);
					rec.serviceRequestDesc = serviceDef
						? this.getRequestTypeDesc(rec.serviceRequestTypeId) + ': ' + serviceDef.description
						: this.getRequestTypeDesc(rec.serviceRequestTypeId);
				} else {
					rec.serviceRequestDesc = this.getRequestTypeDesc(rec.serviceRequestTypeId);
				}
				rec['agencyName'] = this.getAgencyName(rec.agencyId);
				rec.requestStatusDesc = this.getRequestStatusDesc(rec.requestStatusId);
				rec.collabList = '';

				const i: number = this.records.findIndex(r => r.id === id);
				if (i === -1) {
					return;
				}
				this.records[i] = rec;
				this.selectedRecord = rec;
				if (this.dataSource) {
					this.dataSource.data = this.records;
					this.onChangeStatusFilterValue();
					this.dataSource.sort = this.sort;
					this.setPagination(this.Idx, this.dataSource.filteredData.length);
				}
			},
			(error: any) => {
				console.error(error);
			}
		);
	}
}
